import { effect, inject, signal, Signal, WritableSignal } from "@angular/core";
import { Project } from "@core/types/sidebar.type";
import { getUrlSegments } from "@core/utils/navigation.utils";
import { Customer, HttpService } from "@core/services/http/http.service";
import { CORE_ROUTES } from "@core/constants/routes.constant";
import { CurrentEntity } from "@core/types/navigation.type";

export class CurrentContextService {
  private readonly urlSegments: Signal<Array<string | null>> = getUrlSegments(1, 2, 3);

  currenEntity: WritableSignal<CurrentEntity> = signal(null);

  currenModule: WritableSignal<string | null> = signal(null);

  private readonly _http: HttpService = inject(HttpService);

  constructor () {
    effect(() => {
      const [ mainTab, idOrAdminModule, module ]: Array<string | null> = this.urlSegments();
      const number: number | null = idOrAdminModule && !Number.isNaN(idOrAdminModule) ? Number.parseInt(idOrAdminModule, 10) : null;

      if (number) {
        this.currenModule.set(module ?? null);

        if (mainTab === CORE_ROUTES.PROJECTS && number) {
          this._http.getProject(number).subscribe((entity: Project): void => {
            this.currenEntity.set({ entity, type: "project" });
          });
        } else if (mainTab === CORE_ROUTES.CUSTOMERS && number && !Number.isNaN(number)) {
          this._http.getCustomer(number).subscribe((entity: Customer): void => {
            this.currenEntity.set({ entity, type: "customer" });
          });
        }
      } else if (mainTab === CORE_ROUTES.ADMINISTRATION) {
        this.currenEntity.set({ entity: null, type: "administration" });
        this.currenModule.set(idOrAdminModule ?? null);
      } else
        this.currenEntity.set(null);
    }, { allowSignalWrites: true });
  }
}

